export class UnresolvableReferenceError extends Error {
    constructor(link){
        super(`Could not resolve ${link.link_type} link with ID '${link.primary_key}'`);
    }
}

//# sourceMappingURL=UnresolvableReferenceError.js.map